import displayFlash from "partners/scripts/display_flash"

import * as $ from "jquery"

export default function reviewPipelineActions() {
  $("table[data-target=reviewer-actions").on(
    "click",
    "button[data-action=add-reviewer]",
    function (e) {
      e.preventDefault()
      const data = { service_id: $(this).data("service") }
      const url = $(this).data("url-add")

      $.ajax({
        url:
          url +
          "?authenticity_token=" +
          window.encodeURIComponent(window.App.authenticityToken),
        type: "PATCH",
        data,
        success: data => {
          $(this)
            .html("Unassign " + data.username)
            .parent()
            .prev("td")
            .text(data.username)
          $(this).attr("data-action", "remove-reviewer")
        },
        error: () => {
          displayFlash("There has been an error adding a reviewer", "error")
        },
      })
    }
  )

  $("table[data-target=reviewer-actions").on(
    "click",
    "button[data-action=remove-reviewer]",
    function (e) {
      e.preventDefault()
      const data = { service_id: $(this).data("service") }
      const url = $(this).data("url-remove")

      $.ajax({
        url:
          url +
          "?authenticity_token=" +
          window.encodeURIComponent(window.App.authenticityToken),
        type: "PATCH",
        data,
        success: () => {
          $(this).html("Assign yourself").parent().prev("td").text("Unassigned")
          $(this).attr("data-action", "add-reviewer")
        },
        error: () => {
          displayFlash("There has been an error removing a reviewer", "error")
        },
      })
    }
  )
}
